import HongKongMoment from 'moment-timezone';

HongKongMoment.tz.setDefault("Asia/Hong_Kong");

export { HongKongMoment };